<template>
  <li class="accordion__item">
    <div
      class="accordion__trigger"
      :class="{'accordion__trigger_active': visible}"
      @click="open">
      <slot name="accordion-trigger" />
      <template v-if="visible">
        <i
          title="Collapse"
          class="mdi mdi-chevron-up" />
      </template>
      <template v-else>
        <i
          title="Expand"
          class="mdi mdi-chevron-down" />
      </template>
    </div>

    <transition
      name="accordion"
      @enter="start"
      @after-enter="end"
      @before-leave="start"
      @after-leave="end">
      <div
        class="accordion__content"
        v-show="visible">
        <ul>
          <slot name="accordion-content" />
        </ul>
      </div>
    </transition>
  </li>
</template>

<script>
export default {
  props: {},
  inject: ['Accordion'],
  data () {
    return {
      index: null,
    }
  },
  computed: {
    visible () {
      return this.index === this.Accordion.active
    },
  },
  created () {
    this.index = this.Accordion.count++
  },
  methods: {
    open () {
      if (this.visible) {
        this.Accordion.active = null
      } else {
        this.Accordion.active = this.index
      }
    },
    start (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    end (el) {
      el.style.height = ''
    },
  },
}
</script>

<style lang="scss" scoped>
  .accordion__item {
    cursor: pointer;
    padding: 1em 2em;
    border-bottom: 0.1em solid #ebebeb;
    position: relative;
    list-style: none;
    background: white;
  }

  .accordion__trigger {
    display: flex;
    justify-content: space-between;
  }

  .accordion__item:hover {
    background: #ececec;
  }

  .accordion-enter-active,
  .accordion-leave-active {
    will-change: height, opacity;
    transition: height 0.3s ease, opacity 0.3s ease;
    overflow: hidden;
  }

  .accordion-enter,
  .accordion-leave-to {
    height: 0;
    opacity: 0;
  }
</style>
